import "firebase/auth"

import * as firebase from 'firebase'

import { ADD_TAG_ERROR, ADD_TAG_REQUEST, ADD_TAG_SUCCESS, DELETE_TAG_REQUEST, DELETE_TAG_SUCCESS, GET_TAG_LIST_ERROR, GET_TAG_LIST_REQUEST, GET_TAG_LIST_SUCCESS, UPDATE_TAG_ERROR, UPDATE_TAG_REQUEST, UPDATE_TAG_SUCCESS } from '../constants/TagConstants'
import { call, delay, put, takeLatest } from 'redux-saga/effects'

import { HirmeDBPATH } from '../components/docs/helperData'
import _ from 'lodash'
import { db } from '../components/firebase'

let tenantId = localStorage.getItem('tenantId')

async function getList(){
    let array = []
   // let tenantId = localStorage.getItem('tenantId')
    let tagRef = `${HirmeDBPATH}/${tenantId}/quiz_tags`
    let categoryList = db.collection(tagRef).where("isDeleted", "==", false).orderBy('created_at', 'desc')
    await categoryList.get()
    .then(snapshot => {
        if (snapshot.empty) {
          return;
        }
        snapshot.forEach(doc => {
            array.push({...doc.data(), id: doc.id})
        })
    })
    return array
}

function* getTagsList(){
    try{
        const list = yield call(getList)
        yield put({ type: GET_TAG_LIST_SUCCESS, list })
    }
    catch(error){
        const err = error.message
        yield put({ type: GET_TAG_LIST_ERROR, err })
    }
}

function addTagdata(data){
    //let tenantId = localStorage.getItem('tenantId')
    let tagRef = `${HirmeDBPATH}/${tenantId}/quiz_tags`
    return firebase.firestore().collection(tagRef).add(data)
    .then(response => response)
}

function* addTag(values){
    try{
        const { data } = values
        yield call(addTagdata, data)
        yield put({ type: ADD_TAG_SUCCESS })
        yield call(getTagsList)
    }
    catch(error){
        const err = error.message
        yield put({ type: ADD_TAG_ERROR, err })
    }
}

function updateTagData(id, data){
    let tagRef = `${HirmeDBPATH}/${tenantId}/quiz_tags`
    return firebase.firestore().collection(tagRef).doc(id).set(data, {merge: true})
    .then(response => response)
}

function* updateTag(values){
    try{
        const { Id, data } = values
        yield call(updateTagData, Id, data)
        yield put({ type: UPDATE_TAG_SUCCESS })
        yield call(getTagsList)
    }
    catch(error){
        const err = error.message
        yield put({ UPDATE_TAG_ERROR, err })
    }
}

function getNewList(list, id){
    let obj = {}
    _.forEach(list, function(value){
        if(value.id === id){
            obj = value
        }
    })
    return obj
}

function* deleteTag(values){
    const { id } = values
    const list = yield call(getList)
    const newList = yield call(getNewList, list, id)
    newList.isDeleted = true
    let tagRef = `${HirmeDBPATH}/${tenantId}/quiz_tags`
    firebase.firestore().collection(tagRef).doc(id).update(newList)
    yield put({ type: DELETE_TAG_SUCCESS, id })
    yield delay(1500)
    yield call(getTagsList)
}

export default () => {
    function * watcher() {
      yield takeLatest(GET_TAG_LIST_REQUEST, getTagsList)
      yield takeLatest(ADD_TAG_REQUEST, addTag)
      yield takeLatest(UPDATE_TAG_REQUEST, updateTag)
      yield takeLatest(DELETE_TAG_REQUEST, deleteTag)
    }
    return {watcher}
}